import { AbilityBuilder, Ability } from '@casl/ability'

import Customer from '@/models/customer'

export default function getBookingAbilitiesFor(customer: Customer): Ability {
  return AbilityBuilder.define({ subjectName: () => 'Booking' }, (can: any) => {
    if (customer) {
      can('update', 'Booking', { customerId: customer.id })
    }
  })
}
